import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationModalDataInterface } from './confirmation-modal-data.interface';

import '@diekeure/dcr-components/dcr-filled-button.js';
import '@diekeure/dcr-components/dcr-inline-button.js';
import '@diekeure/dcr-components/dcr-outline-button.js';
import '@diekeure/dcr-components/dcr-tonal-button.js';

@Component({
  standalone: false,
  selector: 'campus-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
})
export class ConfirmationModalComponent implements ConfirmationModalDataInterface {
  title: string;
  message: string;
  disableConfirm: boolean;
  confirmLabel: string;
  cancelLabel: string;
  confirmType: 'default' | 'danger' | 'primary';
  cancelType: 'default' | 'inline' | 'hidden';
  confirmIcon: string;
  messageClass: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: ConfirmationModalDataInterface,
    public dialogRef: MatDialogRef<ConfirmationModalComponent>
  ) {
    this.title = data.title;
    this.message = data.message;
    this.disableConfirm = data.disableConfirm;
    this.confirmLabel = data.confirmLabel || 'Ja';
    this.cancelLabel = data.cancelLabel || 'Nee';
    this.confirmType = data.confirmType || 'primary';
    this.cancelType = data.cancelType || 'inline';
    this.confirmIcon = data.confirmIcon;
    this.messageClass = data.messageClass || '[ label-large on-surface text-opacity-medium ]';
  }

  public cancel() {
    this.dialogRef.close(false);
  }

  public confirm() {
    if (this.disableConfirm) return; // workaround because stop propagation does not work
    this.dialogRef.close(true);
  }
}
